(function() {
  var COOKIE_NAME = 'mamitas_age_verified';
  var gate = document.getElementById('age-gate');
  if (!gate) return;

  function lockScroll() {
    document.documentElement.style.overflowY = 'hidden';
    document.body.style.overflow = 'hidden';
    document.documentElement.style.touchAction = 'none';
  }
  function unlockScroll() {
    var lockStyle = document.getElementById('gate-scroll-lock');
    if (lockStyle && lockStyle.parentNode) lockStyle.parentNode.removeChild(lockStyle);
    document.documentElement.style.overflowY = '';
    document.body.style.overflow = '';
    document.documentElement.style.touchAction = '';
    window.scrollTo(0, 0);
  }

  // Check cookie
  if (document.cookie.indexOf(COOKIE_NAME + '=1') !== -1) {
    gate.style.display = 'none';
    unlockScroll();
    showSite();
    triggerHeroIntro();
    return;
  }

  // Lock scroll while gate is visible
  lockScroll();

  var btnYes = document.getElementById('btn-yes');

  btnYes.addEventListener('click', function() {
    // Set cookie for 30 days
    var d = new Date();
    d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
    document.cookie = COOKIE_NAME + '=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';

    // Show the hero behind the gate (still hidden visually by gate on top)
    showSite();

    // Fade out the gate content (logo, stickers, buttons)
    gate.classList.add('gate-exit');

    // Start Perlin noise dissolve of the water background
    setTimeout(function() {
      var bgCanvas = document.getElementById('bg-gate');
      var bgSrc = bgCanvas ? bgCanvas.dataset.bgSrc : '';
      if (typeof startGateDissolve === 'function' && bgSrc) {
        startGateDissolve(bgSrc);
      } else {
        gate.style.display = 'none';
      }
      // Trigger hero intro exactly as dissolve starts revealing the page behind
      triggerHeroIntro();
      unlockScroll();
    }, 600);
  });

  function showSite() {
    var hidden = document.querySelectorAll('[style*="display:none"], [style*="display: none"]');
    hidden.forEach(function(el) {
      if (el.id !== 'age-gate') {
        el.style.display = '';
      }
    });
  }

  function triggerHeroIntro() {
    var hero = document.getElementById('home');
    if (!hero || hero.classList.contains('intro-ready')) return;
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        hero.classList.add('intro-ready');
        window.dispatchEvent(new CustomEvent('mamitas:age-gate-cleared'));
      });
    });
  }
})();
